module.exports = __webpack_public_path__ + "img/qui.2c69f47b.jpg";